<template>
  <section id="hero" data-component="hero">
    <LazyBg :src="bgSrc" eager />
    <canvas ref="canvasEl" id="hero-canvas">您的浏览器不支持 Canvas 动画</canvas>
    <div class="hero-overlay" />
    <div class="hero-content">
      <div class="hero-badge">
        云游戏解决方案
      </div>
      <h1 class="display-xl hero-title">
        高质量云游戏<br /><span class="gradient-text">从芯片到系统的全栈优化</span>
      </h1>
      <p class="hero-subtitle">
        深度联动国内GPU芯片厂商，打通芯片底层至系统软件全链路优化，针对渲染、编解码模块专项性能升级，规模化部署分布式边缘算力资源。依托云端算力分发能力，低配终端即可流畅运行高品质手游、PC 端游与主机 3A 大作，全方位拓宽多场景云游戏业务生态。
      </p>
      <div class="hero-actions">
        <RouterLink :to="{ path: '/', hash: '#cta-contact' }" class="btn-primary">
          获取解决方案报价
          <svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
            <path d="M5 12h14M12 5l7 7-7 7" />
          </svg>
        </RouterLink>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import bgSrc from '@/assets/cloudgame_bg1.jpg';
import LazyBg from '@/components/LazyBg.vue';
import { ref } from 'vue';
import { RouterLink } from 'vue-router';
import { useHeroCanvas } from '@/composables/useHeroCanvas';
import '@/styles/newhome/home/hero.css';

const canvasEl = ref<HTMLCanvasElement | null>(null);
useHeroCanvas(canvasEl);
</script>
<style scoped lang="scss">
 #hero {
  /* bg via LazyBg */
}
</style>